module.exports = __webpack_public_path__ + "img/0910c_1.459a9b3b.jpg";